import { Trip } from "../Trip/Trip";
import { Week } from "../Week/Week";

export class State{

    week:Week;
    metadata:Map<string,any> = new Map<string,any>();
    constructor(week:Week){
        this.week = week;
        this.metadata = new Map<string,any>();
    }

    setMetadata<T>(key:string,value:T){
        this.metadata.set(key,value)
    }

    getMetadata<T>(key:string){
        return this.metadata.get(key)
    }
}


// WEBPACK FOOTER //
// ./src/app/DataStructures/State/State.ts